import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { entryTabs } from "@/mocks/siteData";

export default function EntryTypes() {
  const [active, setActive] = useState(entryTabs[0].key);
  const current = entryTabs.find((tab) => tab.key === active) ?? entryTabs[0];

  return (
    <section id="entries" className="py-16 md:py-24 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label tracking-[0.2em] uppercase text-accent-400">
            <span className="w-6 h-px bg-accent-400" />
            Entry Types
          </span>
          <h2 className="mt-3 text-2xl md:text-4xl font-heading font-bold text-background-50 leading-snug">
            常见的四类入口，分别适合什么情况
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-background-300">
            入口并不是只有一种。桌面浏览器、手机浏览器、备用线路与镜像入口各有侧重，切换下方标签即可查看每种入口的适用场景与注意事项。
          </p>
        </div>

        <div
          className="mt-8 flex flex-wrap gap-2 p-1 rounded-full bg-background-900/60 border border-background-800 w-fit"
          role="tablist"
          aria-label="入口类型"
        >
          {entryTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={active === tab.key}
              onClick={() => setActive(tab.key)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
                active === tab.key
                  ? "bg-accent-500 text-foreground-950"
                  : "text-background-200 hover:text-background-50 hover:bg-background-800"
              }`}
            >
              <i className={tab.icon} />
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="p-6 rounded-2xl bg-background-900 border border-background-800 h-full">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/15 text-accent-400">
                <i className={`${current.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 text-xl font-heading font-bold text-background-50">
                {current.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-300">
                {current.desc}
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="p-6 rounded-2xl bg-background-900 border border-background-800 h-full">
              <h4 className="text-sm font-label tracking-widest text-background-400 uppercase">
                注意事项
              </h4>
              <ul className="mt-4 space-y-3">
                {current.points.map((point) => (
                  <li key={point} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-secondary-500/20 text-secondary-300 shrink-0 mt-0.5">
                      <i className="ri-check-line text-xs" />
                    </span>
                    <span className="text-sm leading-relaxed text-background-100">
                      {point}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}